// eslint-disable-next-line
import {
  Button,
  Dialog,
  DialogContent,
  Grid,
  Table,
  TableContainer,
  TableRow,
  TableCell,
  TextField,
  Typography,
  TableBody,
  Paper,
  TableHead,
  InputLabel,
  MenuItem,
  FormHelperText,
  FormControl,
  Select
} from '@material-ui/core'
import queryString from "query-string";
import { history } from "../../_redux/_store/history";
import CancelIcon from '@material-ui/icons/Cancel'
import React, { useEffect } from 'react'
import { makeStyles, withStyles } from '@material-ui/styles'
import {
  getRecommendation,
  updateRecommendation,
  clearRecommendationState,
} from '../../_redux/_actions/recommendationListActions'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import ErrorHandler from '../updateHandlers/ErrorHandler'

const useStyles = makeStyles(() => ({
  button: {
    width: '100px',
    marginRight: '20px',
    '&:hover': {
      background: '#52A1C2',
    },
    '&:focus-visible': {
      background: '#52A1C2',
    },
  },
  findingDetailsStyle:{
    fontSize: '13px !important'
  }
}))

const StyledTableCell = withStyles((theme) => ({
  head: {
    color: 'white',
    backgroundColor: 'grey'
  },
  body: {
    fontSize: 14,
  },
}))(TableCell)

const StyledDialog = withStyles((theme) => ({
  paperWidthSm: {
    maxWidth: '750px',
  },
  paperScrollPaper: {
    width: '750px',   
  },
}))(Dialog)

const Accordion = withStyles({
  root: {
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
  },
  expanded: {},
})(MuiAccordion)

const AccordionSummary = withStyles({
  root: {
    marginBottom: -1,
  },
})(MuiAccordionSummary)

const AccordionDetails = withStyles((theme) => ({
  root: {
    border: '1px solid rgb(222, 222, 222)'
  },
}))(MuiAccordionDetails)

export default function EditRecommendation(props) {
  const { editRecommendation, handleEditDialog, handleUpdateSuccess } = props
  const classes = useStyles()
  const dispatch = useDispatch()
  const recommendation = useSelector((state) => state.recommendation)
  const [scopedFindings, setScopedFindings] = useState('')
  const [description, setDescription] = useState('')
  const [effortText, setEffortText] = useState("");
  const [roleText, setRoleText] = useState("");
  const [effortValue, setEffortValue] = useState("");
  const [roleValue, setRoleValue] = useState("");
  const [errorEffortValue, setErrorEffortValue] = useState(false);
  const [errorRoleValue, setErrorRoleValue] = useState(false);
  const [expanded, setExpanded] = useState(true)
  const queryValues = queryString.parse(history.location.search)
  const {machine_type, hmi_type} = queryValues

  useEffect(() => {
    dispatch(getRecommendation(editRecommendation,machine_type, hmi_type))
    return () => {
      dispatch(clearRecommendationState())
    }
  }, [])

  useEffect(() => {
    if (recommendation.singleRecommendation) {
      setScopedFindings(
        recommendation.singleRecommendation.prioritizedSuggestions
      )
    }
  }, [recommendation.singleRecommendation])

  useEffect(() => {
    if (recommendation.singleRecommendation) {
      setDescription(
        recommendation.singleRecommendation.description
      )
    }
  }, [recommendation.singleRecommendation])

  useEffect(() => {
    if (recommendation.singleRecommendation) {
      switch(recommendation.singleRecommendation.department) {
        case "O":
          // code block
          setRoleText(1)
          setRoleValue("O")
          break;
        case "M":
          // code block
          setRoleText(2)
          setRoleValue("M")
          break;
          case "E":
            // code block
          setRoleText(3)
          setRoleValue("E")
          break;
          case "M+E":
          setRoleText(4)
          setRoleValue("M+E")
            break;
        // default:
        //   // code block
      }
      switch(recommendation.singleRecommendation.effort) {
        case "XS":
          // code block
          setEffortText(1)
          setEffortValue("XS")

          break;
        case "S":
          // code block
          setEffortText(2)
          setEffortValue("S")
          break;
          case "M":
            // code block
          setEffortText(3)
          setEffortValue("M")
          break;
          case "L":
            // code block
          setEffortText(4)
          setEffortValue("L")
            break;
        // default:
        //   // code block
      } 
    }
  }, [recommendation.singleRecommendation])


  const handleEffortChange = (event) => {
    setEffortText(event.target.value)
    if (event.target.value === 1) {
      setEffortValue("XS");
      setErrorEffortValue(false)
    } else if (event.target.value === 2) {
      setEffortValue("S");
      setErrorEffortValue(false)
    } else if (event.target.value === 3) {
      setEffortValue("M");
      setErrorEffortValue(false)
    } else if (event.target.value === 4) {
      setEffortValue("L");
      setErrorEffortValue(false)
    } else {
      setErrorEffortValue(true)
    }
    if (!event.target.value) {
      setErrorEffortValue(true)
    }
  };
  const handleRoleChange = (event) => {
    setRoleText(event.target.value)
    if (event.target.value === 1) {
      setRoleValue("O");
      setErrorRoleValue(false)
    }
    else if (event.target.value === 2) {
      setRoleValue("M");
      setErrorRoleValue(false)
    }
    else if (event.target.value === 3) {
      setRoleValue("E");
      setErrorRoleValue(false)
    }
    else if (event.target.value === 4) {
      setRoleValue("M+E");
      setErrorRoleValue(false)
    }
    else {
      setErrorRoleValue(true)
    }
    if (!event.target.value) {
      setErrorRoleValue(true)
    }
  };

  const updateDescription = () => {
    if (errorRoleValue !== true && errorEffortValue !== true && effortValue !== "" && roleValue !== "") {
    let body = {
      id: editRecommendation,
      description: description,
      estimated_duration: null,
      effort: effortValue,
      department: roleValue
    }
      dispatch(updateRecommendation(body, handleUpdateSuccess,machine_type, hmi_type))
    }
    else {
      if (effortValue === "") {
        setErrorEffortValue(true)
      }
      if (roleValue === "") {
        setErrorRoleValue(true)
    }
      }
  }

  //controlled accordion
  const handleAccordionChange = (row) => (event, isExpanded) => {
    setExpanded(isExpanded ? row : false)
  }

  return (
      <>
      {recommendation.error && <ErrorHandler message={recommendation.error} />}
      {recommendation.singleRecommendation && (
        <StyledDialog
          open={editRecommendation ? true : false}
          onClose={handleEditDialog}
        >
          <DialogContent style={{ overflow: 'hidden', height: '100%' }}>
            <Grid container direction="column" justifyContent="center" spacing={3}>
              <Grid
                item
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                style={{ marginTop: '1em' }}
              >
                <Grid item>
                  <Typography style={{ color: '#52A1C2', fontWeight: 700 }}>
                    Edit Recommendation
                  </Typography>
                </Grid>
                <Grid item>
                  <Button onClick={handleEditDialog}>
                    <CancelIcon
                      style={{ color: '#666666' }}
                    />
                  </Button>
                </Grid>
              </Grid>
              <Grid item>
                <TextField
                  label="Description of Recommendation"
                  defaultValue={recommendation.singleRecommendation.description}
                  variant="outlined"
                  rows={6}
                  multiline
                  fullWidth
                  onChange={(e) => setDescription(e.target.value)}
                />
              </Grid>
              <Grid
              container
              direction="row"
              style={{ marginBottom: "20px", marginTop: "30px", padding: "0 15px" }}
            >
              <Grid item md={6}>
                <FormControl
                  required
                  className={classes.formControl}
                  error={errorEffortValue === true ? true : false}
                >
                  <InputLabel shrink id="demo-simple-select-placeholder-label-label">
                    Effort
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-placeholder-label-label"
                    id="handleEffortChange"
                    value={effortText}
                    onChange={handleEffortChange}
                    displayEmpty
                    className={classes.selectEmpty}
                    data-testid="effortChange"
                  >
                    <MenuItem value="" >
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value={1}>XS</MenuItem>
                    <MenuItem value={2}>S</MenuItem>
                    <MenuItem value={3}>M</MenuItem>
                    <MenuItem value={4}>L</MenuItem>
                  </Select>
                  <FormHelperText>    
                  XS: visu only / machine keeps running;
                  S: ~5 min down e.g. during buffer stop;
                  M: up to 1h down;
                  L: {'>'} 1h down
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item md={6}>
                <FormControl
                  required
                  className={classes.formControl}
                  error={errorRoleValue === true ? true : false}
                >
                  <InputLabel shrink id="demo-simple-select-placeholder-label-label">
                    Role
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-placeholder-label-label"
                    id="handleRoleChange"
                    value={roleText}
                    onChange={handleRoleChange}
                    displayEmpty
                    className={classes.selectEmpty}
                    data-testid="roleChange"
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value={1}>O</MenuItem>
                    <MenuItem value={2}>M</MenuItem>
                    <MenuItem value={3}>E</MenuItem>
                    <MenuItem value={4}>M+E</MenuItem>
                  </Select>
                  <FormHelperText>   
                      O: operator;
                      M: mechanic;
                      E: electrician;
                      M+E: mechanic + electrician
                  </FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
              {scopedFindings.length > 0 && (
                <Grid item>
                  <Typography variant="caption">
                    Following are the scoped finding rules associated with the
                    selected recommendation
                  </Typography>
                </Grid>
              )}
              {scopedFindings.length > 0 && (
                <Grid item>
                  <TableContainer
                    component={Paper}
                    style={{ maxHeight: '230px' }}
                  >
                    <Table stickyHeader>
                      <TableHead >
                        <TableRow style={{ backgroundColor: 'grey' }}>
                          <StyledTableCell>
                            <Typography style={{ color: 'white' }}>
                              Scope
                            </Typography>
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            <Typography style={{ color: 'white' }}>
                              Finding Rule Name
                            </Typography>
                          </StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody style={{ overflowY: 'scroll' }}>
                        {scopedFindings &&
                          scopedFindings.map((finding) => {
                            return (
                              <TableRow
                                key={
                                  finding.scoped_finding_rule_finding_rule_id
                                }
                                style={{ height: 10 }}
                              >
                                  <TableCell scope="row">
                                  <Accordion
                                  square
                                  elevation={0}
                                  defaultExpanded={true}
                                  onChange={handleAccordionChange(finding.scopedFindingRule.scope)}
                                  >
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls='panel1a-content'
                                      id='panel1'
                                    >
                                      {finding.scopedFindingRule.scope}
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      <Grid direction='column'>
                                        <Grid item style={{marginBottom: '10px',fontSize : '11px', fontWeight: 'bold'}}>
                                          Note Text <Typography className={classes.findingDetailsStyle}>{finding.scopedFindingRule.note_text}</Typography>
                                        </Grid>
                                        <Grid item style={{fontSize : '11px', fontWeight: 'bold'}}>
                                          Description <Typography className={classes.findingDetailsStyle}>{finding.scopedFindingRule.findingRule.description}</Typography>
                                        </Grid>
                                      </Grid>
                                    </AccordionDetails>
                                  </Accordion>
                                  </TableCell>
                                    <TableCell scope="row">
                                    {finding.scopedFindingRule.findingRule.name}
                                  </TableCell>
                              </TableRow>
                            )
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              )}
              <Grid
                item
                container
                direction="row"
                style={{ marginBottom: '10px' }}
              >
                <Grid item>
                  <Button
                    variant="outlined"
                    disableFocusRipple
                    className={classes.button}
                    onClick={() => updateDescription()}
                  >
                    Done
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="outlined"
                    disableFocusRipple
                    className={classes.button}
                    onClick={handleEditDialog}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
        </StyledDialog>
      )}
   </>
  )
}
